import axios from '@/axios'

const GROWTH_STAGE_IMAGE_PREFIX = '/api/screen-config/growth-stage-image'

/**
 * 分页查询生长阶段图片列表
 * @param {Object} params - 分页参数
 * @returns {Promise}
 */
export const fetchGrowthStageImageList = (params = {}) => {
  return axios.post(`${GROWTH_STAGE_IMAGE_PREFIX}/list-page`, params)
}

/**
 * 新增生长阶段图片
 * @param {Object} payload - 包含 sortOrder, stageName, imageUrl
 * @returns {Promise}
 */
export const addGrowthStageImage = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return Promise.reject(new Error('payload is required'))
  }
  return axios.post(`${GROWTH_STAGE_IMAGE_PREFIX}/add`, payload)
}

/**
 * 编辑生长阶段图片
 * @param {Object} payload - 包含 id 和其他字段
 * @returns {Promise}
 */
export const editGrowthStageImage = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return Promise.reject(new Error('payload is required'))
  }
  return axios.post(`${GROWTH_STAGE_IMAGE_PREFIX}/edit`, payload)
}

/**
 * 获取生长阶段图片详情
 * @param {String|Number} id - 图片ID
 * @returns {Promise}
 */
export const getGrowthStageImageDetail = (id) => {
  if (!id && id !== 0) {
    return Promise.reject(new Error('growth stage image id is required'))
  }
  return axios.post(`${GROWTH_STAGE_IMAGE_PREFIX}/detail/${id}`)
}

/**
 * 批量删除生长阶段图片
 * @param {Array} ids - 图片ID数组
 * @returns {Promise}
 */
export const batchDeleteGrowthStageImage = (ids) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return Promise.reject(new Error('ids array is required'))
  }
  return axios.post(`${GROWTH_STAGE_IMAGE_PREFIX}/delete-batch`, ids)
}
